export default {"src":"/_next/static/media/facebook.9d336d1a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};